/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUploadAssetUrlResponse
 */
export interface GetUploadAssetUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof GetUploadAssetUrlResponse
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof GetUploadAssetUrlResponse
     */
    fileName: string;
}

/**
 * Check if a given object implements the GetUploadAssetUrlResponse interface.
 */
export function instanceOfGetUploadAssetUrlResponse(value: object): value is GetUploadAssetUrlResponse {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    return true;
}

export function GetUploadAssetUrlResponseFromJSON(json: any): GetUploadAssetUrlResponse {
    return GetUploadAssetUrlResponseFromJSONTyped(json, false);
}

export function GetUploadAssetUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUploadAssetUrlResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'fileName': json['fileName'],
    };
}

export function GetUploadAssetUrlResponseToJSON(json: any): GetUploadAssetUrlResponse {
    return GetUploadAssetUrlResponseToJSONTyped(json, false);
}

export function GetUploadAssetUrlResponseToJSONTyped(value?: GetUploadAssetUrlResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'fileName': value['fileName'],
    };
}

